// extracted by mini-css-extract-plugin
export default {"secondaryColor":"#374152","card":"customCardStyle_card__zjkhm","media":"customCardStyle_media__CkazG","cost":"customCardStyle_cost__Xy4uf"};